/**
 * Shared MongoDB-style database filter constants
 * Used across selectors, thunks, and components for consistent query patterns
 */

/**
 * Standard filter to exclude soft-deleted records
 * Use this instead of inline: { $or: [{ deleted: { $exists: false } }, { deleted: false }] }
 */
export const NOT_DELETED_FILTER = {
    $or: [{ deleted: { $exists: false } }, { deleted: false }]
} as const;

/**
 * Helper to create a query that includes the not-deleted filter
 * @param additionalFilters - Additional query filters to merge with the not-deleted filter
 * @returns Combined query object
 */
export function withNotDeletedFilter<T extends Record<string, any>>(additionalFilters: T): T & typeof NOT_DELETED_FILTER {
    return {
        ...additionalFilters,
        ...NOT_DELETED_FILTER,
    };
}
